<template>
    <common-modal v-if="isOpen" width="small" class="details-modal" @close="emitEvent({ name: 'close' })">
        <div class="details-modal__container">
            <h2 class="details-modal__head">
                {{ $t('modals.patient_profile.profile.request.record_request.details_modal.req_details') }}
                {{ $t('modals.patient_profile.profile.request.record_request.req') }}{{ request.id }}
            </h2>

            <div class="details-grid">
                <div class="field-item">
                    <label class="field-label">
                        {{ $t('modals.patient_profile.profile.detail_form.detail_view.fields.provider') }}
                    </label>
                    <p class="field-value font-medium">{{ request.toProviderName }}</p>
                </div>

                <div class="field-item">
                    <label class="field-label">
                        {{ $t('modals.patient_profile.profile.detail_form.detail_view.fields.status') }}
                    </label>
                    <div>
                        <span :class="['status', request.status ? request.status.toLowerCase() : '']">
                            <common-icon :name="getIcon(request.status)" size="tiny"></common-icon>
                            {{ formatStatus(request.status) }}
                        </span>
                    </div>
                </div>

                <div class="field-item">
                    <label class="field-label">
                        {{ $t('modals.patient_profile.profile.request.record_request.details_modal.req_date') }}
                    </label>
                    <p class="field-value">{{ dateFormate(request.createdDateTime) }}</p>
                </div>

                <div v-if="request.expected" class="field-item">
                    <label class="field-label">{{ $t('modals.patient_profile.profile.record_form.request_id.expected') }}</label>
                    <p class="field-value">{{ request.expected }}</p>
                </div>
            </div>

            <div class="stacked-fields">
                <div class="field-item">
                    <label class="field-label">
                        {{ $t('modals.patient_profile.profile.request.record_request.details_modal.req_records') }}
                    </label>
                    <p class="field-value">{{ request.recordTypes?.join(', ') || '-' }}</p>
                </div>

                <div class="field-item">
                    <label class="field-label">
                        {{ $t('modals.patient_profile.profile.request.record_request.details_modal.hipaa_auth') }}
                    </label>
                    <p class="field-value">{{ hipaaAuthNameDisplay }}</p>
                </div>

                <div class="field-item">
                    <label class="field-label">{{ $t('modals.patient_profile.profile.record_form.notes.name') }}</label>
                    <p class="field-value">{{ request.notes || '-' }}</p>
                </div>
            </div>
        </div>
    </common-modal>
</template>

<script>
    import { dateFormate } from '~/helpers'

    export default {
        props: {
            request: { type: Object, required: true },
            isOpen: { type: Boolean, required: true },
            availHipaaForms: { type: Array, default: () => [] },
        },
        computed: {
            hipaaAuthNameDisplay() {
                if (!this.request || !this.request.hipaaFormId) return '-'
                const form = (this.availHipaaForms || []).find((f) => f.id === this.request.hipaaFormId)
                if (form && form.authorizationName) {
                    return form.authorizationName
                }
                return this.request.hipaaFormId
            },
        },
        methods: {
            dateFormate,
            emitEvent(payload) {
                this.$emit(payload.name)
            },
            getIcon(status) {
                const map = {
                    PENDING: 'timer',
                    APPROVED: 'check-circle',
                    REJECTED: 'close',
                    RECEIVED: 'download',
                }
                return map[status?.toUpperCase()] || 'info'
            },
            formatStatus(status) {
                if (!status) return ''
                return status.toLowerCase().replace(/(?:^|\s|-|_)\w/g, (match) => match.toUpperCase())
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .details-modal {
        &__container {
            padding: 8px 4px;
        }

        &__head {
            margin-top: 0;
            margin-bottom: 20px;
            font-size: 18px;
            font-weight: 600;
            color: #0a0a0a;
        }
    }

    .details-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        margin-bottom: 16px;
    }

    .stacked-fields {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .field-item {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .field-label {
        font-size: 13px;
        font-weight: 500;
        color: #6b7280;
    }

    .field-value {
        font-size: 14px;
        color: #111827;
        margin: 0;

        &.font-medium {
            font-weight: 500;
        }
    }

    .status {
        padding: 1.75px 7px;
        border-radius: 6.75px;
        font-size: 10.5px;
        font-weight: 500;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        gap: 3.5px;
        line-height: 1.4;
        width: fit-content;

        &.pending {
            background: #fef9c2;
            color: #894b00;

            :deep(i) {
                color: #894b00;
            }
        }

        &.received {
            background: #dbeafe;
            color: #193cb8;

            :deep(i) {
                color: #193cb8;
            }
        }

        &.approved {
            background: #dcfce7;
            color: #016630;

            :deep(i) {
                color: #016630;
            }
        }

        &.rejected {
            background: #ffe2e2;
            color: #9f0712;

            :deep(i) {
                color: #9f0712;
            }
        }
    }
</style>
